import React from "react";
import { ShoppingCart, Check } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "@/context/CartContext";

export default function AddToCartButton({ book, size = "md", className = "" }) {
  const { add, items, setOpen } = useCart();
  const inCart = items.find((i) => i.book_id === book.id);

  const onClick = () => {
    add(book, 1);
    toast.success(inCart ? `Added another to cart` : `Added "${book.title.slice(0, 40)}" to cart`, {
      action: { label: "View cart", onClick: () => setOpen(true) },
    });
  };

  const sizeCls = size === "sm" ? "h-9 text-xs px-3" : "h-10 text-sm px-4";

  return (
    <button
      data-testid={`add-to-cart-${book.id}`}
      onClick={onClick}
      className={`inline-flex items-center justify-center gap-1.5 rounded-full border border-[#0F172A] text-[#0F172A] hover:bg-[#0F172A] hover:text-white transition-colors ${sizeCls} ${className}`}
      style={{ transitionProperty: "background-color, color" }}
    >
      {inCart ? <><Check size={size === "sm" ? 12 : 14}/> In cart · {inCart.quantity}</> : <><ShoppingCart size={size === "sm" ? 12 : 14}/> Add to cart</>}
    </button>
  );
}
